module.exports = "pegasus_template/assets/background-patterns/default-pets-theme.jpg";